
const isFile = (dom) => {
  if (!dom.classList) {
    return false;
  }
  if (dom.classList.contains('file')) {
    return true;
  }
  if (dom.classList.contains('tree-root')) {
    return false;
  }
  return isFile(dom.parentNode);
};

const isFolder = (dom) => {
  if (!dom.classList) {
    return false;
  }
  if (dom.classList.contains('folder')) {
    return true;
  }
  if (dom.classList.contains('file')) {
    return false;
  }
  if (dom.classList.contains('tree-root')) {
    return false;
  }
  return isFolder(dom.parentNode);
};

export { isFile, isFolder };
